module.exports = new __parcel__URL__("image-product-2.26974f01.jpg").toString();